// extracted by mini-css-extract-plugin
export default {"groupPermissions":"GroupPermissions_groupPermissions__jqeu1","flexContainer":"GroupPermissions_flexContainer__DPg3z","flexItemRight":"GroupPermissions_flexItemRight__9zMrv"};